function Introduction(){
    return(
        <section>
            <p>I’m currently developing professional ecommerce stores on the Shopify platform for a wide range of mostly Swedish and other European retail brands.</p>
        </section>
    )
}

export default Introduction